export interface ReportLimiterOptions {
  maxPerFingerprint: number
  maxPerSession: number
  /** 버스트 소진 후 토큰 1개가 차는 데 걸리는 시간 */
  minIntervalMs: number
  /** 즉시 허용되는 연속 전송 수 */
  burst: number
}

/**
 * 전송 유량 제어 — 캡처 루프의 최종 방어선.
 * 핑거프린트당 상한 + 세션 총량 상한 + 토큰버킷 스로틀을 모두 통과해야 전송된다.
 * 모든 드랍은 조용히 일어난다 (로그·예외 없음).
 */
export class ReportLimiter {
  private readonly perFingerprint = new Map<string, number>()
  private totalSent = 0
  private tokens: number
  private lastRefillAt: number
  // 파라미터 프로퍼티 금지: 소비자 tsconfig 의 erasableSyntaxOnly 와 호환되어야 한다
  private readonly options: ReportLimiterOptions

  constructor(options: ReportLimiterOptions) {
    this.options = options
    this.tokens = options.burst
    this.lastRefillAt = 0
  }

  allow(fingerprint: string, now: number): boolean {
    if (this.totalSent >= this.options.maxPerSession) return false

    const sentForFingerprint = this.perFingerprint.get(fingerprint) ?? 0
    if (sentForFingerprint >= this.options.maxPerFingerprint) return false

    this.refill(now)
    if (this.tokens < 1) return false

    this.tokens -= 1
    this.totalSent += 1
    this.perFingerprint.set(fingerprint, sentForFingerprint + 1)
    return true
  }

  private refill(now: number): void {
    if (this.lastRefillAt === 0) {
      this.lastRefillAt = now
      return
    }
    const elapsed = now - this.lastRefillAt
    if (elapsed <= 0) return
    const earned = Math.floor(elapsed / this.options.minIntervalMs)
    if (earned > 0) {
      this.tokens = Math.min(this.options.burst, this.tokens + earned)
      this.lastRefillAt += earned * this.options.minIntervalMs
    }
  }
}
